import { render, staticRenderFns } from "./containerBill.vue?vue&type=template&id=ca034698&scoped=true"
import script from "./containerBill.vue?vue&type=script&lang=js"
export * from "./containerBill.vue?vue&type=script&lang=js"
import style0 from "./containerBill.vue?vue&type=style&index=0&id=ca034698&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca034698",
  null
  
)

export default component.exports